import React from 'react';
import './PackGrid.css';
import '../full.css';
import {Link} from 'react-router-dom'

const PackGroup = ({
  gridElementSize,
  packGroup,
  showModal
}) => {
  const jditemsStyleObj = {opacity: 1};

  return (
        <div className={'large-'+gridElementSize+' small-12 columns jditems'}  style={jditemsStyleObj}>
          <Link to={"/pack-group/"+packGroup.name} className="wrapper" onClick={showModal.bind(this, 'packGroup', packGroup)}>
            <div className="shadow">
              <img alt="pack group cover" src={process.env.REACT_APP_API_ENDPOINT+packGroup.cover?.url} />
            </div>
            <h2 className="packTitle">{packGroup.synth}<br/>
              <span className="packSubtitle">
                {`${packGroup.title} `}
                {packGroup.packs.map((pack, i) => (
                  <span key={i}>Vol {pack.volume}</span>
                  )).reduce((accu, elem) => {
                      return accu === null ? [elem] : [...accu, ', ', elem]
                  }, null)
                }
              </span>
            </h2>
          </Link>
        </div>
  );
}

export default PackGroup;
